import React, { PureComponent } from 'react';

import { withTracking } from '../../provider';

import ParentMobile from './component';

class ParentMobileContainer extends PureComponent {
  render() {
    const {
      className,
      injected: {
        tracking: { trackButtonClick },
      },
      parentLinks,
    } = this.props;

    if (!parentLinks || !parentLinks.length) return null;

    const componentProps = {
      className,
      parentLink: parentLinks[0],
      onClick: (params) => trackButtonClick('crumb', params),
    };

    return <ParentMobile {...componentProps} />;
  }
}

export default withTracking('breadcrumbs')(ParentMobileContainer);
